import React from 'react';
import "./promptInput.css";
import image from '../../../../../../../../assets/image.svg';
import rightArrow from '../../../../../../../../assets/rightArrow.svg';
import { useStore } from '../../../../../../../../Hooks/useStore';
import { observer } from 'mobx-react';

const PromptInput = observer(({ onSend, loading }) => {
    const { rootStore } = useStore();

    const onPromptEnter = (e) => {
        rootStore.assistantStore.setPrompt(e.target.value);
    }
    const onKeyHandler = (e) => {
        if (e.target.value.trim().length !== 0 && e.key === "Enter") {
          onSend(e.target.value);
        }
      };

    return (
        <div className='prompt-input-container'>
            <input onKeyDown={onKeyHandler} disabled={loading} onChange={onPromptEnter} value={rootStore.assistantStore.getPrompt} type='text' placeholder='Type a message' className='prompt-input' />
            <div className='chat-send-btn'>
                {/* <button className='img-send-btn'>
                    <img src={image} alt='chat image send' />
                </button> */}
                <button className='msg-send-btn' onClick={() => onSend(rootStore.assistantStore.getPrompt)}>
                    <img src={rightArrow} alt='chat image send' />
                </button>
            </div>
        </div>
    );
})

export default PromptInput;
